import { toast } from "sonner";

/** Copy text and confirm only once the write has actually succeeded. */
export async function copyText(text: string, success: string): Promise<boolean> {
  try {
    if (!navigator.clipboard) throw new Error("Clipboard unavailable");
    await navigator.clipboard.writeText(text);
    toast(success);
    return true;
  } catch {
    toast.error("Couldn't copy to the clipboard");
    return false;
  }
}
